<template>
  <b-card class="m-1 col-md-5">
    <h5 class="mb-0">Rounding Method (Global)</h5>
    <small class="text-muted mb-3 d-block">You can change the default rounding method applied to this invoice by selecting from the options below.</small>

    <v-select
      v-model="roundingMethodSelected"
      :options="roundingMethodList"
      class="bg-white"
      :clearable="false"
      :disabled="!$isDev"
      @input="setRoundingMethod"
      id="slidepanel-edit-quote-tabs-details-rounding-method-list"
      code="id"
      label="description"
    ></v-select>
  </b-card>
</template>

<script>
  import MODULE from "@/constants/modules";
  import GlobalServices from "@/services/global";
  import InvoiceService from "@/services/invoice";
  const invoiceService = new InvoiceService();
  const global = new GlobalServices();
  export default {
    name: "TaxRateSelection",
    props: {
      dataObj: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        roundingMethodSelected: null,
        roundingMethodList: [],
      };
    },
    methods: {
      setRoundingMethod(evt) {
        this.updateField("ApplicationCurrencyRoundingOption", evt.id, "Application Currency Rounding Option", evt.description, MODULE.INVOICE.UX.RoundingMethodActionId);
      },
      async init() {
        this.roundingMethodList = await global.getUXDropDown(MODULE.INVOICE.UX.RoundingMethodActionId);
        if (this.dataObj) {
          this.getPresetData();
        }
      },
      async getPresetData() {
        const details = await invoiceService.getInvoiceEditPreset(this.dataObj.id);
        // @TODO: select rounding method id
        if (details && details.applicationCurrencyRoundingOption) this.roundingMethodSelected = this.roundingMethodList.find((rm) => rm.id === details.applicationCurrencyRoundingOption);
      },
      async updateField(propertyName, propertyValue, displayName, displayValue = null, overrideActionId = null, immediate = false) {
        let editObj = {};
        editObj.propertyName = propertyName;
        editObj.propertyValue = propertyValue;
        editObj.displayName = displayName;
        editObj.displayValue = displayValue;
        editObj.id = this.dataObj.id;
        if (overrideActionId) editObj.actionId = overrideActionId;
        editObj.isUXProperty = true;
        let isValid = await this.isValidated(propertyName, propertyValue);

        if (isValid) {
          this.postAPIData(editObj, immediate);
        }
      },
      async isValidated(propertyName, propertyValue) {
        //Prevent empty value from being sent
        if (propertyValue == null || propertyValue.length == 0) return false;

        return true;
      },
      async postAPIData(dataObj, immediate = false) {
        if (immediate) {
          await global.postData(dataObj);
        } else {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.timer = setTimeout(() => {
            global.postData(dataObj);
          }, 500);
        }
      },
    },
    mounted() {
      this.init();
    },
  };
</script>
